import React from 'react'
import useLearningCenter from '~/app/hooks/use-learning-center'
import {editorStateMap} from '../utils'

export interface ActiveGoalButtonTextProps {
    conditionMetText: string
    conditionNotMetText: string
    stateToShowInEditor: string
    isEdit: boolean
    'data-testid'?: string
}

export const ActiveGoalButtonText = ({
    conditionMetText,
    conditionNotMetText,
    stateToShowInEditor,
    isEdit
}: ActiveGoalButtonTextProps) => {
    const {getActiveGoal} = useLearningCenter()
    const activeGoal = getActiveGoal()

    const renderButtonChildren = () => {
        if (isEdit) {
            return stateToShowInEditor === editorStateMap.CONDITION_MET
                ? conditionMetText
                : conditionNotMetText
        } else {
            return activeGoal ? conditionMetText : conditionNotMetText
        }
    }

    return <div>{renderButtonChildren()}</div>
}
